(function() {
    'use strict';
    /*
     * Copyright (c) 2014-2017 In Hand Health.
     * All rights reserved.
     */

    /**
     * The percent filter displays a number as a percent with the specified number of decimal places.
     *
     * @memberof ihh-filters
     * @ngdoc filter
     * @name percent
     */
    angular
        .module('ihh-filters')
        .filter('percent', percentFilter);

    percentFilter.$inject = ['$filter'];

    function percentFilter($filter) {

        /**
         * Returns a number formatted as a percent.
         *
         * @func percentFilter
         * @memberOf percent
         * @param {Number} number - the number to format
         * @param {Number} decimalPlaces - the number of decimal places to display
         * @returns {String} the number formatted as a percent
         */
        return function(number, decimalPlaces) {
            if (angular.isNumber(number)) {
                return $filter('number')(number * 100, decimalPlaces) + '%';
            }
            else {
                return null;
            }
        };
    }
})();